import { ContactData } from '@cp-mx/common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { MyContactSelector } from './MyContactSelector';
import { fetchMyContact } from './MyContactSlice';

export function useMyContact(): AbstractDataState<ContactData, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMyContact, MyContactSelector);
}
